import React, { Component, Suspense } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import Bowser from 'bowser'

import { WEB_HTTP_CONTEXT } from '@am92/web-http'

import Loader from './Components/Loader'

import AppRouter from './AppRouter'

import {
  getAccessTokenSelector,
  getRefreshTokenSelector
} from './Redux/Auth/Selectors'
import performHandshake from './Services/performHandshake'

import { TAppDispatch, TAppStore } from './Configurations/AppStore'
import { asHttp } from './Configurations/WebHttp'
import { setDeviceDetails } from './Redux/Auth/Reducer'
import { googleAnalytics } from './utils/GoogleAnalytics'
import { addNativeDisplayEvents } from './Redux/AppState/Reducer'

export interface IAppInitializerProps extends PropsFromRedux { }

export interface IAppInitializerState {
  hasError: boolean
  isLoading: boolean
  handshakeComplete: boolean
}

const DEFAULT_STATE: IAppInitializerState = {
  hasError: false,
  isLoading: false,
  handshakeComplete: false
}

class AppInitializer extends Component<
  IAppInitializerProps,
  IAppInitializerState
> {
  state = DEFAULT_STATE

  async componentDidMount() {
    this.setDeviceIdHeader()
    this.setTokensIfExist()
    this.setDeviceDetails()
    await this.initialize()
    this.listenClevertapNativeDisplayKVEvents()
    googleAnalytics()
  }

  initialize = async () => {
    this.setState({ isLoading: true })
    try {
      await performHandshake()
      this.setState({ isLoading: false, handshakeComplete: true })
      // Handle All Your app Level Initialisations here
    } catch (error) {
      // Handle Error Appropriately or wrap in error boundary
      console.log('AppInitializer error', error)
      this.setState({ isLoading: false, hasError: true }, () => {
        throw error
      })
    }
  }

  setTokensIfExist = () => {
    const { accessToken, refreshToken } = this.props
    if (accessToken) {
      asHttp.context.set(WEB_HTTP_CONTEXT.ACCESS_TOKEN, accessToken)
    }

    if (refreshToken) {
      asHttp.context.set(WEB_HTTP_CONTEXT.REFRESH_TOKEN, refreshToken)
    }
  }

  setDeviceDetails = () => {
    const { actions } = this.props
    actions.setDeviceDetails({
      deviceName:
        Bowser.parse(window.navigator.userAgent).browser.name +
        ' ' +
        Bowser.parse(window.navigator.userAgent).browser.version ||
        'Not Fetched',
      osType:
        Bowser.parse(window.navigator.userAgent).os.name +
        ' ' +
        Bowser.parse(window.navigator.userAgent).os.version || 'Not Fetched'
    })
  }

  handleClevertapEventKV = (event: any) => {
    const payload = event?.detail

    if (payload) {
      this.props.actions.addNativeDisplayEvents(payload)
    }
  }

  listenClevertapNativeDisplayKVEvents = () => {
    document.addEventListener(
      'CT_web_native_display',
      this.handleClevertapEventKV
    )
  }

  setDeviceIdHeader = () => {
    const deviceId = localStorage.getItem('device_id')
    if (deviceId) {
      asHttp.client.defaults.headers.common['X-DeviceId'] = deviceId
    }
  }







  render() {
    const { handshakeComplete, hasError, isLoading } = this.state
    return (
      <Suspense fallback={<Loader />}>
        {(!hasError && !isLoading && handshakeComplete && <AppRouter />) || (
          <Loader />
        )}
      </Suspense>
    )
  }
}

const mapStateToProps = (state: TAppStore) => {
  const accessToken = getAccessTokenSelector(state)
  const refreshToken = getRefreshTokenSelector(state)
  return {
    accessToken,
    refreshToken
  }
}

const mapDispatchToProps = (dispatch: TAppDispatch) => ({
  actions: {
    setDeviceDetails: (requestData: any) =>
      dispatch(setDeviceDetails(requestData)),
    addNativeDisplayEvents: (data: any) =>
      dispatch(addNativeDisplayEvents(data))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AppInitializer)
